/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getRetailGroupByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetRetailGroupById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getRetailGroupByIdIdRegExpTwo)]).optional()
});

export type GetRetailGroupById = zod.input<typeof GetRetailGroupById>;
export type GetRetailGroupByIdOutput = zod.output<typeof GetRetailGroupById>;
